import React from 'react';

const ToggleSwitchNo = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="28" viewBox="0 0 44 28" fill="none">
      <g clipPath="url(#clip0_513_467)">
        <rect width="44" height="28" rx="14" fill="#6D7885" />
        <g filter="url(#filter0_dd_513_467)">
          <circle cx="14" cy="14" r="12" fill="white" />
        </g>
        <path d="M14.008 15.16L10.4131 18.7531C10.2527 18.9135 10.0582 18.9919 9.82958 18.9883C9.60101 18.9848 9.40651 18.9028 9.24608 18.7425C9.08565 18.5821 9.00543 18.3859 9.00543 18.1539C9.00543 17.9219 9.08565 17.7258 9.24608 17.5654L12.8304 13.983L9.23542 10.4176C9.07499 10.2573 8.99655 10.0611 9.00012 9.82906C9.00366 9.59705 9.08565 9.40087 9.24608 9.24052C9.40651 9.08017 9.60279 9 9.83493 9C10.067 9 10.2633 9.08017 10.4238 9.24052L14.008 12.8336L17.5753 9.24052C17.7357 9.08017 17.9302 9 18.1588 9C18.3874 9 18.5819 9.08017 18.7423 9.24052C18.9141 9.41223 19 9.61125 19 9.83759C19 10.0639 18.9141 10.2573 18.7423 10.4176L15.158 13.983L18.753 17.576C18.9134 17.7364 18.9936 17.9308 18.9936 18.1593C18.9936 18.3877 18.9134 18.5821 18.753 18.7425C18.5812 18.9142 18.3821 19 18.1556 19C17.9292 19 17.7357 18.9142 17.5753 18.7425L14.008 15.16Z" fill="#6D7885" />
      </g>
      <defs>
        <filter id="filter0_dd_513_467" x="0" y="0" width="28" height="29" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_513_467" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_513_467" result="effect2_dropShadow_513_467" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_513_467" result="shape" />
        </filter>
        <clipPath id="clip0_513_467">
          <rect width="44" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ToggleSwitchNo;